import createCrudVuexModule from "@/store/crud";

export const managementComplianceItem = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/compliance-item",
  actions: {
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        await dispatch("update", payload);
      } else {
        await dispatch("create", payload);
      }
      commit("reset");
    },
  },
});

export const managementComplianceItemGroup = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/compliance-item-group",
});

export const libraryComplianceItemGroup = createCrudVuexModule({
  namespaced: true,
  path: "/library/compliance-item-group",
});

export const libraryComplianceItem = createCrudVuexModule({
  namespaced: true,
  path: "/library/compliance-item",
});
